// removed by extract-text-webpack-plugin
module.exports = {"root":"_2Cdcc","selector":"_1ku11","selectorArrowIcon":"_14DjO","open":"_37J9M","dropdown":"_1Ugfj","modal":"_1uQ4l","mask":"_to9Cn","header":"_3CT2N","list":"_1FuMr","listItem":"_20YH6","selected":"_xQi93"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/components/SubscriptionSection/components/Dropdown/Dropdown.scss
// module id = 1327
// module chunks = 3